import React from 'react';
import CountUp from 'react-countup';
import { Container, Row, Col } from 'react-bootstrap';
import { FaProjectDiagram, FaUsers, FaHeadset, FaAward } from 'react-icons/fa';
import '../styles/StatsCounter.css';

const StatsCounter = () => {
  const stats = [
    { icon: <FaProjectDiagram />, title: "Projects Delivered", count: 150 },
    { icon: <FaUsers />, title: "Happy Clients", count: 120 },
    { icon: <FaHeadset />, title: "Support Tickets Resolved", count: 5000 },
    { icon: <FaAward />, title: "Years of Experience", count: 10 },
  ];

  return (
    <section className="stats-section py-5 text-center">
      <Container>
        <h2 className="section-title mb-5">Our Achievements</h2>
        <Row>
          {stats.map((stat, index) => (
            <Col key={index} md={3} sm={6} className="mb-4">
              <div className="stat-box h-100">
                <div className="stat-icon">{stat.icon}</div>
                <div className="stat-count">
                  <CountUp
                    end={stat.count}
                    duration={3}            // Slower count
                    delay={index * 1.5}     // Delay one by one
                    separator=","
                  />
                  {stat.title === "Years of Experience" ? '+' : ''}
                </div>
                <div className="stat-title">{stat.title}</div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default StatsCounter;
